import {mapGetters} from 'vuex';

export default {
    computed: {
        ...mapGetters('marketing', [
            'advisory_partner_profile',
        ]),
        colorScheme() {
            return this.advisory_partner_profile?.theme_color || 'indigo';
        },
        isCalculatorEnabled() {
            return !this.isPartner || (this.advisory_partner_profile?.is_calculator_enabled || false);
        },
        isExternalLinkAvailable() {
            return !this.isPartner || this.advisory_partner_profile?.is_kb_available;
        },
        isOnboardingEnabled() {
            return !this.isPartner || (this.advisory_partner_profile?.is_onboarding_enabled || true);
        },
        isOilGasQuestionnaireEnabled() {
            return this.advisory_partner_profile?.is_oil_gas_questionnaire_enabled || false;
        },
        isRiskAnalysisEnabled() {
            return this.advisory_partner_profile?.is_risk_analysis_enabled || false;
        },
        isPartner() {
            const profileKeys = Object.keys(this.advisory_partner_profile).length;
            return (profileKeys > 0 && (this.advisory_partner_profile.name || '') !== 'Valur');
        },
        partnerName() {
            return this.advisory_partner_profile.name || 'Valur';
        },
        privacyPolicyContent() {
            return this.advisory_partner_profile?.privacy_policy;
        },
        termsOfServiceContent() {
            return this.advisory_partner_profile?.terms_of_service;
        },
        websiteDisclosureContent() {
            return this.advisory_partner_profile?.website_disclosure;
        },
    },
    methods: {
        async fetchClients() {
            return await this.$store.dispatch('marketing/listAdvisorClients', {
                advisor_id: this.advisor_profile.id,
                advisory_partner_id: this.advisory_partner_profile.id,
            });
        },
    },
    watch: {
        advisory_partner_profile: {
            immediate: true,
            handler(val) {
                if (val) {
                    const font = new FontFace('WhiteLabel', `url("${val.font_url}")`);
                    document.fonts.add(font);
                } else {
                    const font = new FontFace('WhiteLabel', 'url("/fonts/RecklessNeue-Bold.otf")');
                    document.fonts.add(font);
                }
            },
        },
    },
};
